import { KioskType } from 'types/KioskTypes';

import SHAREBOX_KIOSK_REOPEN_STEPS from './sharebox';
import PARTTEAM_KIOSK_REOPEN_STEPS from './partteam';

export default {
  [KioskType.PARTTEAM]: PARTTEAM_KIOSK_REOPEN_STEPS,
  [KioskType.SHAREBOX]: SHAREBOX_KIOSK_REOPEN_STEPS,
};
